module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAADCAYAAABF//VLAAAAR0lEQVQImWPMPHP+PwORgAVZnRg7G4OvuBiDGg83mH/ry1eGjS9eMbz59QvMZ0JWnCovy6DDx8vAxsQExiB2uoIsRJKBgQEAvpkN8tdkkdAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coupon.png
// module id = NXC6
// module chunks = 16